(function () {
  function currentStepFromUrl() {
    return (new URL(window.location.href).searchParams.get('step') || '').trim().toLowerCase();
  }

  function applyHighlight(root, stepKey) {
    var steps = root.querySelectorAll('[data-dlux-routine-step]');
    Array.prototype.forEach.call(steps, function (el) {
      var key = (el.getAttribute('data-step-key') || '').toLowerCase();
      el.classList.toggle('is-highlighted', Boolean(stepKey) && key === stepKey);
    });
  }

  function scrollToStep(root, stepKey) {
    if (!stepKey) return;
    var target = root.querySelector('[data-dlux-routine-step][data-step-key="' + stepKey + '"]');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - 24;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  function sync(root, doScroll) {
    var stepKey = currentStepFromUrl();
    applyHighlight(root, stepKey);
    if (doScroll) scrollToStep(root, stepKey);
  }

  function bindViewAllLinks(root) {
    var links = root.querySelectorAll('.dlux-routine-overview__view-all');
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        var url;
        try {
          url = new URL(href, window.location.origin);
        } catch (e) {
          return;
        }
        var stepParam = url.searchParams.get('step');
        var samePath = url.pathname === window.location.pathname;
        if (!samePath || !stepParam) return;

        event.preventDefault();
        window.history.pushState({}, '', url.toString());
        sync(root, true);
      });
    });
  }

  function init(root) {
    bindViewAllLinks(root);
    window.addEventListener('popstate', function () {
      sync(root, true);
    });
    sync(root, Boolean(currentStepFromUrl()));
  }

  function boot() {
    document.querySelectorAll('[data-dlux-routine-overview]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
